/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 7ff9d9a75799e9e6fc2e65b3327c25b6 */

import { ConcreteRequest } from "relay-runtime";

import {  } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type SupportedMFATypes = "CODE" | "%future added value";
export type UserLoginInput = {
    email?: string | null | undefined;
    password?: string | null | undefined;
    socialToken?: string | null | undefined;
    socialUserFirstName?: string | null | undefined;
    socialUserLastName?: string | null | undefined;
    socialUserEmail?: string | null | undefined;
    socialClientId?: string | null | undefined;
    socialNetworkName?: string | null | undefined;
    authHash: string;
    cookieDomain?: string | null | undefined;
    marketingOptIn?: boolean | null | undefined;
    countryCode?: string | null | undefined;
    captchaToken?: string | null | undefined;
    captchaKey?: string | null | undefined;
    mfaVerificationCode?: string | null | undefined;
    supportedMFATypes?: Array<SupportedMFATypes | null> | null | undefined;
    registrationTrigger?: string | null | undefined;
    emailLoginToken?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type loginMutationVariables = {
    input: UserLoginInput;
};
export type loginMutationResponse = {
    readonly userLogin: {
        readonly user: {
            readonly serviceId: string | null;
            readonly userId: string | null;
            readonly createdDate: string | null;
            readonly isVerifiedTrade: boolean | null;
            readonly isVip: boolean | null;
            readonly verifiedTradeStatus: string | null;
            readonly ethereumWalletAddress: {
                readonly address: string | null;
            } | null;
            readonly profile: {
                readonly email: string | null;
                readonly firstName: string | null;
                readonly lastName: string | null;
            } | null;
            readonly preferences: {
                readonly currency: Currency | null;
                readonly measurementUnit: string | null;
                readonly preferredLocale: string | null;
            } | null;
            readonly " $fragmentRefs": FragmentRefs<"tradeApplicationHelpers_user">;
        } | null;
        readonly emailToken: string | null;
        readonly userToken: string | null;
        readonly userId: string | null;
        readonly responseMessage: string | null;
        readonly isNewUser: boolean | null;
        readonly submittedTransactions: number | null;
        readonly confirmedTransactions: number | null;
        readonly submittedTransactionsRecent: number | null;
        readonly confirmedTransactionsRecent: number | null;
    } | null;
};
export type loginMutation = {
    readonly response: loginMutationResponse;
    readonly variables: loginMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceId",
        "storageKey": null
    } as any, v3 = {
        "alias": "userId",
        "args": null,
        "kind": "ScalarField",
        "name": "serviceId",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdDate",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVerifiedTrade",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVip",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "verifiedTradeStatus",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "concreteType": "EthereumAddressType",
        "kind": "LinkedField",
        "name": "ethereumWalletAddress",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "concreteType": "Profile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "concreteType": "UserPreferences",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "measurementUnit",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preferredLocale",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailToken",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userToken",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "responseMessage",
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isNewUser",
        "storageKey": null
    } as any, v16 = {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.submitted"
    } as any, v17 = {
        "alias": "submittedTransactions",
        "args": [
            (v16 /*: any*/)
        ],
        "kind": "ScalarField",
        "name": "transactionsCount",
        "storageKey": "transactionsCount(viewName:\"buyerTracking.submitted\")"
    } as any, v18 = {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.confirmed"
    } as any, v19 = {
        "alias": "confirmedTransactions",
        "args": [
            (v18 /*: any*/)
        ],
        "kind": "ScalarField",
        "name": "transactionsCount",
        "storageKey": "transactionsCount(viewName:\"buyerTracking.confirmed\")"
    } as any, v20 = {
        "kind": "Literal",
        "name": "monthsBack",
        "value": 6
    } as any, v21 = {
        "alias": "submittedTransactionsRecent",
        "args": [
            (v20 /*: any*/),
            (v16 /*: any*/)
        ],
        "kind": "ScalarField",
        "name": "transactionsCount",
        "storageKey": "transactionsCount(monthsBack:6,viewName:\"buyerTracking.submitted\")"
    } as any, v22 = {
        "alias": "confirmedTransactionsRecent",
        "args": [
            (v20 /*: any*/),
            (v18 /*: any*/)
        ],
        "kind": "ScalarField",
        "name": "transactionsCount",
        "storageKey": "transactionsCount(monthsBack:6,viewName:\"buyerTracking.confirmed\")"
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "loginMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UserLoginPayload",
                    "kind": "LinkedField",
                    "name": "userLogin",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                {
                                    "kind": "InlineDataFragmentSpread",
                                    "name": "tradeApplicationHelpers_user",
                                    "selections": [
                                        (v6 /*: any*/),
                                        (v7 /*: any*/)
                                    ]
                                }
                            ],
                            "storageKey": null
                        },
                        (v11 /*: any*/),
                        (v12 /*: any*/),
                        (v13 /*: any*/),
                        (v14 /*: any*/),
                        (v15 /*: any*/),
                        (v17 /*: any*/),
                        (v19 /*: any*/),
                        (v21 /*: any*/),
                        (v22 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutations",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "loginMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UserLoginPayload",
                    "kind": "LinkedField",
                    "name": "userLogin",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v11 /*: any*/),
                        (v12 /*: any*/),
                        (v13 /*: any*/),
                        (v14 /*: any*/),
                        (v15 /*: any*/),
                        (v17 /*: any*/),
                        (v19 /*: any*/),
                        (v21 /*: any*/),
                        (v22 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/loginMutation",
            "metadata": {},
            "name": "loginMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '041e82a3b62b2fde09b245803dc1e5f2';
export default node;
